import React, { useEffect } from 'react'
import {
  makeStyles,
  Card,
  CardContent,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,

} from '@material-ui/core'
import {
  withStyles,
} from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { useNavigate, useParams } from 'react-router-dom'
import { getGroups } from 'src/app/slices/refereeGroupsSlice'
import { addUser, getUser, editUser } from '../../app/slices/usersSlice'

// const refereeLevel = ['مرحله ۱', 'مرحله 2']

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(TextField)

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: 'orange',
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

const CssSelect = withStyles({
  root: {
    '& MuiSelect.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(FormControl)

const CssDatePicker = withStyles({
  root: {
    '& label.Mui-focused': {
      color: 'orange',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: 'orange',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: 'orange',
      },
    },
  },
})(DatePicker)

const useStyle = makeStyles(() => ({
  root: {
    borderRadius: '20px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '30px',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: '#f9b233',
    },
    '& .MuiOutlinedInput-input:focus': {
      outline: 'red',
    },
    '& .MuiMenuItem-root': {
      '&:hover': {
        backgroundColor: '#f9b233',
      },
    },
    '.MuiMenuItem-root': {
      backgroundColor: '#f9b233',
    },
  },
  MuiPaper: {
    root: {
      MuiMenu: {
        paper: {
          borderRadius: '50px',

        },
      },

    },
  },
  inputs: {
    width: '100%',
  },
  MuiListItem: {
    root: {
      '&.Mui-selected:hover': {
        backgroundColor: '#f9b233',
      },
    },
  },
  selectRol: {
    '& .MuiList-root': {
      borderRadius: '50px',
    },
  },
  menuItem: {
    '&::selected': {
      backgroundColor: 'red',
    },
    '&:hover': {
      backgroundColor: '#fef6e7',
    },

  },
  myInput: {
    border: 'none',
    outline: 'none !important',
    '&:focus': {
      border: 'none',
      outline: 'none !important',
    },
  },
  focusInput: {
    color: '#000',
    outline: 'none !important',
  },
  list: {
    borderRadius: '5px',
    top: '300px !important',
    border: '1px solid #f9b233',
  },
  datePicker: {
    '& .MuiPickersDatePickerRoot-toolbar': {
      backgroundColor: 'orange !important',
    },
  },
  addBtn: {
    display: 'flex',
    justifyContent: 'end',
  },
}))

const validationSchema = yup.object({
  userName: yup
    .string('لطفا نام کاربری را وارد کنید')
    .required('نام کاربری الزامی است.'),
  password: yup
    .string('رمز عبور خود را وارد کنید.')
    .min(8, 'رمزعبور حداقل باید ۸ کاراکتر باشد.')
    .required('رمز عبور الزامی است'),
  role: yup
    .string('نقش را انتخاب کنید.')
    .required('انتخاب نقش الزامی است'),
})

const UserForm = () => {
  const classes = useStyle()
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { userId } = useParams()
  const loggedInUser = useSelector((state) => state.user)
  const groups = useSelector((state) => state.refereeGroups.list)

  const roles = useSelector((state) => {
    if (loggedInUser.role.roleId === 8) {
      return state.common.roles
    }
    if (loggedInUser.role.roleId === 5 || loggedInUser.role.roleId === 10) {
      return state.common.roles.filter((role) => role.roleId === 6)
    }
    if (loggedInUser.role.roleId === 3) {
      return state.common.roles.filter(
        (role) => (
          role.roleId !== 2 && role.roleId !== 1 && role.roleId !== 8 && role.roleId !== 3
        ),
      )
    }
    if (loggedInUser.role.roleId === 2) {
      return state.common.roles.filter((role) => role.roleId !== 1)
    }
    return []
  })

  const userInfo = useSelector((state) => {
    if (userId) {
      return state.users.current
    }
    return null
  })

  useEffect(() => {
    if (userId) {
      dispatch(getUser(userId))
    }
    dispatch(getGroups({}))
  }, [])

  console.log('userInfo', userInfo)
  console.log(groups, 'gfyjyukiuyo')

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      userName: userInfo?.userName || '',
      firstName: userInfo?.profile?.firstName || '',
      lastName: userInfo?.profile?.lastName || '',
      phoneNumber: userInfo?.profile?.phoneNumber || '',
      password: userInfo?.password || '',
      expireDate: userInfo?.expireDate || null,
      role: userInfo?.role?.roleId || 6,
    },
    validationSchema,
    onSubmit: (values) => {
      if (userId) {
        dispatch(editUser({
          userId,
          userName: values.userName,
          profile: {
            firstName: values.firstName,
            lastName: values.lastName,
            phoneNumber: values.phoneNumber,
          },
          newPassword: values.password === 'gnet_tmp_pass_token' ? null : values.password,
          role: {
            roleId: values.role,
          },
          expireDate: values.expireDate && new Date(values.expireDate).toISOString(),
        }, () => navigate('../../')))
      } else {
        dispatch(addUser({
          // ...values,
          userName: values.userName,
          profile: {
            firstName: values.firstName,
            lastName: values.lastName,
            phoneNumber: values.phoneNumber,
          },
          password: values.password,
          role: {
            roleId: values.role,
          },
          expireDate: values.expireDate && values.expireDate.toISOString(),
        }, () => navigate('..')))
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit}>
      <Card className={classes.root}>
        <CardContent>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <CssTextField
                fullWidth
                variant="outlined"
                // disabled={!!userId}
                id="userName"
                name="userName"
                label="نام کاربری"
                value={formik.values.userName}
                onChange={formik.handleChange}
                error={formik.touched.userName && Boolean(formik.errors.userName)}
                helperText={formik.touched.userName && formik.errors.userName}
                InputProps={{
                  style: { border: '1px solid red !important' },
                  classes: { input: classes.myInput, focused: classes.focusInput },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CssTextField
                fullWidth
                variant="outlined"
                // disabled={!!userId}
                id="firstName"
                name="firstName"
                label="نام"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                helperText={formik.touched.firstName && formik.errors.firstName}
                InputProps={{
                  style: { border: '1px solid red !important' },
                  classes: { input: classes.myInput, focused: classes.focusInput },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CssTextField
                fullWidth
                variant="outlined"
                // disabled={!!userId}
                id="lastName"
                name="lastName"
                label="نام خانوادگی"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                helperText={formik.touched.lastName && formik.errors.lastName}
                InputProps={{
                  style: { border: '1px solid red !important' },
                  classes: { input: classes.myInput, focused: classes.focusInput },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CssTextField
                fullWidth
                variant="outlined"
                // disabled={!!userId}
                id="phoneNumber"
                name="phoneNumber"
                label="شماره همراه"
                value={formik.values.phoneNumber}
                onChange={formik.handleChange}
                error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                InputProps={{
                  style: { border: '1px solid red !important' },
                  classes: { input: classes.myInput, focused: classes.focusInput },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CssTextField
                fullWidth
                id="password"
                variant="outlined"
                name="password"
                label="رمزعبور"
                type="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                error={formik.touched.password && Boolean(formik.errors.password)}
                helperText={formik.touched.password && formik.errors.password}
                InputProps={{
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CssSelect variant="outlined" fullWidth className={classes.formControl}>
                <InputLabel id="roleLable">نقش</InputLabel>
                <Select
                  labelId="roleLable"
                  id="role"
                  name="role"
                  value={formik.values.role}
                  onChange={formik.handleChange}
                  label="نقش"
                  MenuProps={{ classes: { paper: classes.list } }}
                  InputProps={{
                  }}
                >
                  {roles.map((role) => (
                    <StyledMenuItem
                      value={role.roleId}
                      className={classes.selectRol}
                      classes={{ root: classes.menuItem }}
                    >
                      {role.name}
                    </StyledMenuItem>
                  ))}
                </Select>
              </CssSelect>
            </Grid>

            {/* {loggedInUser?.role?.roleId === 10
              ? (
                <>
                  <Grid item xs={12} sm={6}>
                    <CssSelect variant="outlined" fullWidth className={classes.formControl}>
                      <InputLabel id="roleLable">انتخاب مرحله داوری</InputLabel>
                      <Select
                        labelId="roleLable"
                        id="level"
                        name="level"
                        // value={formik.values.role}
                        onChange={formik.handleChange}
                        label="مرحله"
                        MenuProps={{ classes: { paper: classes.list } }}
                        InputProps={{
                        }}
                      >
                        {refereeLevel.map((level, i) => (
                          <StyledMenuItem
                            key={i}
                            value={level}
                            className={classes.selectRol}
                            classes={{ root: classes.menuItem }}
                          >
                            {level}
                          </StyledMenuItem>
                        ))}
                      </Select>
                    </CssSelect>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <CssSelect variant="outlined" fullWidth className={classes.formControl}>
                      <InputLabel id="roleLable">انتخاب گروه داروی</InputLabel>
                      <Select
                        labelId="roleLable"
                        id="group"
                        name="group"
                        value={formik.values.role}
                        onChange={formik.handleChange}
                        label="گروه"
                        MenuProps={{ classes: { paper: classes.list } }}
                        InputProps={{
                        }}
                      >
                        {groups.map((g, i) => (
                          <StyledMenuItem
                            key={i}
                            value={g?.id}
                            className={classes.selectRol}
                            classes={{ root: classes.menuItem }}
                          >
                            {g?.name}
                          </StyledMenuItem>
                        ))}
                      </Select>
                    </CssSelect>
                  </Grid>
                </>
              )
              : null} */}

            <Grid item xs={12} sm={6}>
              <CssDatePicker
                inputVariant="outlined"
                label="تاریخ انقضا"
                fullWidth
                clearable
                okLabel="تأیید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                value={formik.values.expireDate}
                DialogProps={{ className: classes.datePicker }}
                onChange={(e) => {
                  formik.setFieldValue('expireDate', e)
                }}
                InputProps={{
                }}
              />
            </Grid>
            <Grid item xs={12} className={classes.addBtn}>
              <Button color="primary" variant="contained" type="submit">
                ثبت
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </form>
  )
}

export default UserForm
